<template>
  <v-container id="usuarios" tag="section">
    <base-v-component heading="Usuarios del sistema " />
    <base-material-card
      color="indigo"
      icon="mdi-account-multiple"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn color="success" dark class="mb-2" @click.stop="showDialog()">{{
          formTitle
        }}</v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          dark
          class="mb-2"
          @click.stop="adaptarUsuariosV2()"
          >Adaptar Usuarios V2
        </v-btn>

        <v-spacer></v-spacer>
        <!-- <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn> -->
        <!-- Dialog formulario-->
        <v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-row>
                  <v-col cols="8">
                    <v-select
                      v-model="general.rol"
                      :items="roles"
                      label="Rol"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="8">
                    <v-text-field
                      @input="$v.general.email.$touch()"
                      @blur="$v.general.email.$touch()"
                      v-model="general.email"
                      label="Email"
                      :error-messages="emailErrors"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      @input="$v.general.pass.$touch()"
                      @blur="$v.general.pass.$touch()"
                      label="contraseña"
                      v-model="general.pass"
                      :error-messages="passErrors"
                    />
                  </v-col>
                </v-row>
                <v-row v-if="general.rol == 'partner'">
                  <v-col cols="6">
                    <v-select
                      v-model="validPartner.partner"
                      :items="partners"
                      label="Partners"
                      item-text="nombre"
                      item-value="id"
                    />
                  </v-col>
                </v-row>
                <v-row
                  v-if="
                    general.rol == 'tpv' ||
                    general.rol == 'tpv-comandero' ||
                    general.rol == 'tpv-repartidor'
                  "
                >
                  <v-col cols="6">
                    <v-select
                      v-model="validTpv.negocioTpv"
                      :items="negociosSelect"
                      label="Negocio"
                      :error-messages="negocioErrors"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      v-model="validTpv.restTpv"
                      :items="restaurantesFiltrados"
                      item-value="id"
                      item-text="nombre"
                      label="Restaurante del negocio"
                    />
                  </v-col>
                </v-row>
                <v-row v-if="general.rol == 'boss_directorio'">
                  <v-col cols="6">
                    <v-select
                      v-model="validDirectorio.directorioGest"
                      :items="directoriosSelect"
                      :error-messages="directorioGestErrors"
                      label="Directorio"
                    />
                  </v-col>
                </v-row>
                <v-row v-if="general.rol == 'boss_negocio'">
                  <v-col cols="6">
                    <v-select
                      v-model="validNegocio.negocioGest"
                      :items="negociosSelect"
                      label="Negocio"
                      :error-messages="negocioGestErrors"
                    />
                  </v-col>
                </v-row>

                <v-row v-if="general.rol == 'boss_restaurante'">
                  <v-col cols="6">
                    <v-select
                      v-model="validRestaurante.negocioRestGest"
                      :items="negociosSelect"
                      label="Negocio"
                      :error-messages="negocioErrors"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      multiple
                      v-model="validRestaurante.restaurantesRestGest"
                      :items="restaurantesFiltrados"
                      item-value="id"
                      item-text="nombre"
                      label="Restaurante del negocio"
                      placeholder="¿De dónde es dueño?"
                    />
                  </v-col>
                </v-row>
                <v-row v-if="general.rol == 'cliente'">
                  <v-col cols="4">
                    <v-text-field
                      v-model="displayName"
                      label="Nombre"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="8">
                    <VuePhoneNumberInput
                      v-model="tlfModel"
                      @update="changePhone"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="save"
                :loading="loadingForm"
                >Guardar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--dialog cambio contraseña-->
        <v-dialog v-model="changePass" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">Cambiar Contraseña</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-row>
                  <v-spacer />
                  <v-col cols="6">
                    <v-text-field
                      v-model="cambioPass.nuevoPass"
                      label="Nueva contreña"
                      @input="$v.cambioPass.nuevoPass.$touch()"
                      @blur="$v.cambioPass.nuevoPass.$touch()"
                      :error-messages="nuevoPassErrors"
                    />
                  </v-col>
                  <v-spacer />
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="changePass = false"
                >Cancelar</v-btn
              >
              <v-btn
                color="blue darken-1"
                text
                @click="saveNuevoPass"
                :loading="loadingForm"
                >Guardar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--dialog cambio perfil -->
        <v-dialog v-model="changePerfil" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">Cambiar Perfil</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-row>
                  <v-spacer />
                  <v-col cols="6">
                    <v-text-field
                      v-model="cambioPerfil.displayName"
                      label="Nueva nombre perfil"
                    />
                  </v-col>
                  <v-spacer />
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="changePerfil = false"
                >Cancelar</v-btn
              >
              <v-btn
                color="blue darken-1"
                text
                @click="saveNuevoPerfil"
                :loading="loadingForm"
                >Guardar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--dialog cambio restaurantes -->
        <v-dialog v-model="changeRestaurantes" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">Cambiar Restaurantes Gestionados</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-row>
                  <v-spacer />
                  <v-col cols="6">
                    <v-select
                      v-model="validRestaurante.negocioRestGest"
                      :items="negociosSelect"
                      label="Negocio"
                      disabled
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      multiple
                      v-model="validRestaurante.restaurantesRestGest"
                      :items="restaurantesFiltrados"
                      item-value="id"
                      item-text="nombre"
                      label="Restaurante del negocio"
                      placeholder="¿De dónde es dueño?"
                    />
                  </v-col>
                  <v-spacer />
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="changeRestaurantes = false"
                >Cancelar</v-btn
              >
              <v-btn
                color="blue darken-1"
                text
                @click="saveRestaurantesGest"
                :loading="loadingForm"
                >Guardar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <!--inicio tabla-->
      <v-data-table
        :headers="headers"
        :items="usuarios"
        :loading="loading"
        :search="search"
      >
        <template v-slot:top>
          <v-row>
            <v-col cols="12" md="4">
              <v-select
                :items="roles"
                @change="buscarRol"
                v-model="filters.role"
                placeholder="Rol..."
                hide-details
                outlined
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" md="6" v-if="filters.role !== 'cliente'">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="8" v-else>
              <v-row justify="center" align="center" dense>
                <v-col cols="2">
                  <v-select
                    :items="selectBuscarUsuario"
                    v-model="filters.campoUsuario"
                    label="Campo buscar"
                  />
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    v-model="campoUsuarioSearch"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-btn @click="buscarUsuario"> Buscar </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <!--
            </v-col>
            <v-col cols="12" md="4">
              <v-btn @click="buscar"> Buscar </v-btn>
            </v-col> -->
          </v-row>
        </template>

        <template v-slot:item.acciones="{ item }">
          <v-spacer></v-spacer>
          <v-tooltip top v-if="item.role.value == 'boss_restaurante'">
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="green"
                min-width="0"
                small
                v-on="on"
                @click="openDialogRestGest(item)"
              >
                <v-icon small>mdi-store</v-icon>
              </v-btn>
            </template>
            <span>Restaurantes gestionados</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="blue"
                min-width="0"
                small
                v-on="on"
                @click="openDialogEditPerfil(item)"
              >
                <v-icon small>mdi-account</v-icon>
              </v-btn>
            </template>
            <span>Cambiar perfil</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="info"
                min-width="0"
                small
                v-on="on"
                @click="$router.push('/admin/usuario/' + item.id)"
              >
                <v-icon small>mdi-eye</v-icon>
              </v-btn>
            </template>
            <span>Ver usuario</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="grey"
                min-width="0"
                small
                v-on="on"
                @click="openDialogNuevoPass(item)"
              >
                <v-icon small>mdi-lock</v-icon>
              </v-btn>
            </template>
            <span>Cambiar contraseña</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="red"
                min-width="0"
                small
                v-on="on"
                :loading="loadingDelete"
                @click="deleteItem(item)"
              >
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Eliminar usuario</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, email } from "vuelidate/lib/validators";
import { mapState, mapGetters } from "vuex";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

export default {
  mixins: [validationMixin],
  validations: {
    general: {
      email: { required, email },
      pass: { required, minLength: minLength(4) },
    },
    validTpv: {
      negocioTpv: { required },
    },
    validRestaurante: {
      negocioRestGest: { required },
      restaurantesRestGest: { required },
    },
    validNegocio: {
      negocioGest: { required },
    },
    validDirectorio: {
      directorioGest: { required },
    },
    validPartner: {
      partner: { required },
    },
    cambioPass: {
      nuevoPass: { required, minLength: minLength(4) },
    },
  },
  components: {
    VuePhoneNumberInput,
  },
  data() {
    return {
      loading: false,
      loadingForm: false,
      loadingDelete: false,
      dialog: false,
      campoUsuarioSearch: "",
      search: "",
      displayName: "",
      phoneNumber: "",
      //restaurantesFiltrados: [],
      //comun
      general: {
        id: null,
        email: "",
        pass: "",
        rol: null,
      },
      validPartner: {
        partner: null,
      },
      //tpv
      validTpv: {
        negocioTpv: null,
        restTpv: null,
      },
      //dueño negocio
      validNegocio: {
        negocioGest: null,
      },
      //dueño directorio
      validDirectorio: {
        directorioGest: null,
      },
      //dueño restaurante
      changeRestaurantes: false,
      validRestaurante: {
        negocioRestGest: null,
        restaurantesRestGest: null,
      },
      emailVerficado: false,
      //cambio pass
      changePass: false,
      cambioPass: {
        nuevoPass: "",
      },
      //cambio perfil
      changePerfil: false,
      cambioPerfil: {
        displayName: "",
      },
      filters: {
        nombre: "",
        role: null,
        campoUsuario: null,
      },
      headers: [
        {
          sortable: false,
          text: "UID",
          value: "uid",
        },
        {
          sortable: false,
          text: "Nombre",
          value: "displayName",
        },
        {
          sortable: false,
          text: "Email",
          value: "email",
        },
        {
          sortable: false,
          text: "Role",
          value: "role.text",
          filter: this.filterRole,
        },
        {
          sortable: false,
          text: "Teléfono",
          value: "telefono",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
    };
  },
  computed: {
    selectBuscarUsuario() {
      return [
        { text: "Teléfono", value: "phoneNumber" },
        {
          text: "UID",
          value: "uid",
        },
      ];
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.general.email.$dirty) return errors;
      !this.$v.general.email.required && errors.push("Email obligatorio.");
      !this.$v.general.email.email && errors.push("Formato no válido.");
      return errors;
    },
    passErrors() {
      const errors = [];
      if (!this.$v.general.pass.$dirty) return errors;
      !this.$v.general.pass.required && errors.push("Contraseña requerida.");
      !this.$v.general.pass.minLength &&
        errors.push("Contraseña demasiada corta.");
      return errors;
    },
    nuevoPassErrors() {
      const errors = [];
      if (!this.$v.cambioPass.nuevoPass.$dirty) return errors;
      !this.$v.cambioPass.nuevoPass.required &&
        errors.push("Contraseña requeridas.");
      !this.$v.cambioPass.nuevoPass.minLength &&
        errors.push("Contraseña demasiada corta.");
      return errors;
    },
    negocioErrors() {
      const errors = [];
      if (!this.$v.validTpv.negocioTpv.$dirty) return errors;
      !this.$v.validTpv.negocioTpv.required &&
        errors.push("Negocio requerido.");
      return errors;
    },
    negocioGestErrors() {
      const errors = [];
      if (!this.$v.validNegocio.negocioGest.$dirty) return errors;
      !this.$v.validNegocio.negocioGest.required &&
        errors.push("Negocio requerido.");
      return errors;
    },
    directorioGestErrors() {
      const errors = [];
      if (!this.$v.validDirectorio.directorioGest.$dirty) return errors;
      !this.$v.validDirectorio.directorioGest.required &&
        errors.push("Directorio requerido.");
      return errors;
    },
    formTitle() {
      return this.isEdit ? "Editar Usuario" : "Nuevo Usuario";
    },
    ...mapState({
      partners: (state) => state.partners.partners,
      roles: (state) => state.users.roles,
      negociosSelect: (state) => state.app.negociosGestArray,
    }),
    directoriosSelect() {
      return this.$store.state.directorios.directorios.map((d) => {
        return {
          text: d.nombre,
          value: d.id,
        };
      });
    },
    ...mapGetters({
      usuarios: "users/usuariosLigero", //"users/usuariosApp",
    }),
    restaurantesFiltrados() {
      var negocioFiltrar = this.validRestaurante.negocioRestGest;
      switch (this.general.rol) {
        case "boss_restaurante":
          negocioFiltrar = this.validRestaurante.negocioRestGest;
          break;
        case "tpv":
          negocioFiltrar = this.validTpv.negocioTpv;
          break;
        case "tpv-comandero":
          negocioFiltrar = this.validTpv.negocioTpv;
          break;
        case "tpv-repartidor":
          negocioFiltrar = this.validTpv.negocioTpv;
          break;
      }
      const rests = this.$store.state.app.restaurantesArray;
      var res = rests.filter((e) => e.negocio == negocioFiltrar);
      return res;
    },
    accion() {
      return this.id ? "edit" : "add";
    },
    isAdd() {
      return this.accion == "add";
    },
    isEdit() {
      return this.accion == "edit";
    },
  },
  watch: {
    dialog(val) {
      val || (this.close() && this.closeDialogRestGest());
    },
    changePass(val) {
      val || this.closeNuevoPass();
    },
    changeRestaurantes(val) {
      val || this.closeDialogRestGest();
    },
    negocioTpv(val) {
      this.$store.commit("app/setNegocioFiltrarRestaurante", val);
      this.validTpv.restTpv = null;
    },
  },
  methods: {
    adaptarUsuariosV2() {
      //función servidor para adaptar usuarios
      this.$store.dispatch("users/adaptarUsuariosV2");
    },
    buscarRol() {
      if (this.filters.role != "cliente") {
        this.loading = true;
        let _vm = this;
        return this.$store
          .dispatch("users/getUsuariosRol", this.filters.role)
          .finally(() => {
            _vm.loading = false;
          });
      }
    },
    buscarUsuario() {
      if (this.filters.role === "cliente") {
        this.loading = true;
        let _vm = this;
        return this.$store
          .dispatch("users/getUsuarioCampo", {
            rol: this.filters.role,
            campo: this.campoUsuarioSearch,
            campoUsuario: this.filters.campoUsuario,
          })
          .finally(() => {
            _vm.loading = false;
          });
      }
    },
    changePhone(val) {
      this.phoneNumber = val.formattedNumber;
    },
    close() {
      this.dialog = false;
      this.$v.$reset();
      let _vm = this;
      setTimeout(() => {
        _vm.reiniciarDatos();
      }, 300);
    },
    reiniciarDatos() {
      this.displayName = "";
      this.phoneNumber = "";
      this.emailVerficado = "";
      this.email = "";
      this.id = null;
    },
    reload() {
      this.getUsers();
    },
    editItemDialog(item) {
      this.displayName = item.displayName;
      this.phoneNumber = item.phoneNumber;
      this.emailVerficado = item.emailVerficado;
      this.email = item.email;
      this.id = item.id;
      this.showDialog();
    },
    addUsuario() {
      let u = {
        email: this.general.email,
        password: this.general.pass,
        role: this.general.rol,
      };
      switch (this.general.rol) {
        case "tpv":
          u.negocioTpv = this.validTpv.negocioTpv;
          u.restauranteTpv = this.validTpv.restTpv;
          break;
        case "tpv-comandero":
          u.negocioTpv = this.validTpv.negocioTpv;
          u.restauranteTpv = this.validTpv.restTpv;
          break;
        case "tpv-repartidor":
          u.negocioTpv = this.validTpv.negocioTpv;
          u.restauranteTpv = this.validTpv.restTpv;
          break;
        case "boss_restaurante":
          u.negocioRestGest = this.validRestaurante.negocioRestGest;
          u.restaurantesRestGest = this.validRestaurante.restaurantesRestGest;
          break;
        case "boss_negocio":
          u.negocioGest = this.validNegocio.negocioGest;
          break;
        case "boss_directorio":
          u.directorioGest = this.validDirectorio.directorioGest;
          break;
        case "partner":
          u.partner = this.validPartner.partner;
          break;
      }
      return this.$store.dispatch("users/addUserAdmin", u);
    },
    save() {
      let _vm = this;
      var valid = false;
      switch (this.general.rol) {
        case "tpv":
          valid = !this.$v.validTpv.$invalid && !this.$v.general.$invalid;
          break;
        case "tpv-comandero":
          valid = !this.$v.validTpv.$invalid && !this.$v.general.$invalid;
          break;
        case "tpv-repartidor":
          valid = !this.$v.validTpv.$invalid && !this.$v.general.$invalid;
          break;
        case "boss_restaurante":
          valid =
            !this.$v.validRestaurante.$invalid && !this.$v.general.$invalid;
          break;
        case "boss_negocio":
          valid = !this.$v.validNegocio.$invalid && !this.$v.general.$invalid;
          break;
        case "boss_directorio":
          valid =
            !this.$v.validDirectorio.$invalid && !this.$v.general.$invalid;
          break;
        case "partner":
          valid = !this.$v.validPartner.$invalid && !this.$v.general.$invalid;
          break;
      }
      if (valid) {
        this.loadingForm = true;
        if (this.isAdd || this.isEdit) {
          this.addUsuario()
            .then((res) => {
              if (!res.data.ok) {
                return Promise.reject(res);
              }
              _vm.$store.commit("snackbar/setMensajeSuccess", {
                msj: "Usuario grabado con éxito",
              });
              _vm.getUsers();
              _vm.dialog = false;
            })
            .catch((error) => {
              console.log(error);
              _vm.$store.commit("snackbar/setMensajeDanger", {
                msj: "Error al guardar el usuario: " + error.data,
              });
            })
            .finally(() => {
              _vm.loadingForm = false;
            });
        }
      }
    },
    getUsers() {
      this.loading = true;
      let _vm = this;
      return this.$store.dispatch("users/getUsuarios").finally(() => {
        _vm.loading = false;
      });
    },
    deleteItem(item) {
      this.$confirm("¿Desea eliminar el usuario? Esta acción es irreversible", {
        buttonTrueText: "Aceptar",
        buttonFalseText: "No",
        color: "warning",
        icon: "warning",
        width: 350,
      }).then((r) => {
        if (r) {
          this.loadingDelete = true;
          let _vm = this;
          this.$store
            .dispatch("users/deleteUser", item)
            .then((res) => {
              _vm.$store.commit("snackbar/setMensajeSuccess", {
                msj: "Usuario eliminado",
              });
              _vm.getUsers();
            })
            .catch((error) => {
              _vm.$store.commit("snackbar/setMensajeDanger", {
                msj: "Error al eliminar: " + error,
              });
            })
            .finally(() => {
              this.loadingDelete = false;
            });
        }
      });
    },
    filterRole(val, search, item) {
      return (
        !this.filters.role ||
        (item.role && this.filters.role == item.role.value)
      );
    },
    showDialog() {
      this.dialog = true;
      //this.$nextTick(this.$refs.nombreReferencia.focus())
    },
    //nuevo pass
    openDialogNuevoPass(item) {
      this.general.id = item.uid;
      this.changePass = true;
    },
    openDialogEditPerfil(item) {
      this.general.id = item.uid;
      this.changePerfil = true;
      this.cambioPerfil.displayName = item.displayName;
    },
    openDialogRestGest(item) {
      this.general.id = item.uid;
      this.changeRestaurantes = true;
      this.validRestaurante.negocioRestGest = item.negocioRestGest;
      this.validRestaurante.restaurantesRestGest = item.restaurantesRestGest;
    },
    closeDialogRestGest() {
      this.changeRestaurantes;
      let _vm = this;
      setTimeout(() => {
        _vm.validRestaurante.negocioRestGest = null;
        _vm.validRestaurante.restaurantesRestGest = null;
      }, 300);
    },
    closeNuevoPass() {
      this.changePass = false;
      this.$v.$reset();
      let _vm = this;
      setTimeout(() => {
        _vm.cambioPass.nuevoPass = "";
      }, 300);
    },
    saveNuevoPass() {
      let _vm = this;
      this.$v.cambioPass.$touch();
      if (!this.$v.cambioPass.$invalid) {
        this.loadingForm = true;
        this.changePassAction()
          .then((res) => {
            if (!res.data.ok) {
              return Promise.reject(res);
            }
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Contraseña guardada con éxito",
            });
            //_vm.getUsers();
            _vm.changePass = false;
          })
          .catch((error) => {
            console.log(error);
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al cambiar la contraseña: " + error.data,
            });
          })
          .finally(() => {
            _vm.loadingForm = false;
          });
      }
    },
    changePassAction() {
      var user = {
        id: this.general.id,
        pass: this.cambioPass.nuevoPass,
      };
      return this.$store.dispatch("users/changePassUserAdmin", user);
    },
    saveNuevoPerfil() {
      let _vm = this;

      this.loadingForm = true;
      this.changePerfilAction()
        .then((res) => {
          if (!res.data.ok) {
            return Promise.reject(res);
          }
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Perfil guardado con éxito",
          });
          _vm.getUsers();
          _vm.changePerfil = false;
        })
        .catch((error) => {
          console.log(error);
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al cambiar el perfil: " + error.data,
          });
        })
        .finally(() => {
          _vm.loadingForm = false;
        });
    },
    changePerfilAction() {
      var user = {
        id: this.general.id,
        displayName: this.cambioPerfil.displayName,
      };
      return this.$store.dispatch("users/changePerfilUserAdmin", user);
    },
    saveRestaurantesGest() {
      var user = {
        id: this.general.id,
        restaurantesRestGest: this.validRestaurante.restaurantesRestGest,
      };
      this.loadingForm = true;
      return this.$store
        .dispatch("users/saveRestaurantesGest", user)
        .then(() => {
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Restaurantes cambiados con éxito",
          });
          this.changeRestaurantes = false;
          this.buscarRol();
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al cambiar los restaurantes: " + error.data,
          });
        })
        .finally(() => {
          this.loadingForm = false;
        });
    },
  },
};
</script>

<style>
</style>